import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Models } from '@ibexfusion/models';
import { CompositionService } from '@services/compositions/composition.service';
import { PackageService } from '@services/packages/package.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { TranslateService } from '@services/translate/translate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenReadmeService } from '@services/readme/open-readme.service';

@Component({
    selector: 'app-package-general',
    templateUrl: './package-general.component.html',
    styleUrls: ['./package-general.component.scss'],
    providers: [PackageService, CompositionService],
    standalone: false
})
export class PackageGeneralComponent implements OnInit {

  public packageId;
  public myPackage: Models.Package;

  @Input() onSave: Observable<any>;
  public messages;
  public qrCodeLinkBase = 'https://go.tweebie.com';
  public webLinkBase = 'https://web.tweebie.com';
  public bookingLinkBase = 'https://swisshotels.com/search-form-action/navigate?language=de&personsPerRoom=2&hotelId=';
  public isTouch2015 = false;
  public isLoading = true;
  private subscription: any;

  constructor(
    private activatedRoute: ActivatedRoute, private packageService: PackageService, private snackbar: SnackbarService, private ts: TranslateService, private readme: OpenReadmeService
  ) {
    this.isLoading = true;
  }

  async ngOnInit() {
    this.messages = this.ts.get('system');
    this.packageId = this.activatedRoute.snapshot.params['id'];

    setTimeout(() => {
      this.initPackage();
    }, 1);

    this.subscription = this.onSave.subscribe(type => {
      if (type === 'general') {
        this.savePackage();
      }
      if (type === 'general-reload') {
        this.initPackage();
      }
    });
  }

  public async initPackage() {
    this.isLoading = true;
    const myPackage = await this.packageService.get(this.packageId);
    if (myPackage && myPackage.tweebie && !myPackage.tweebie.bookingLink) {
      if (myPackage.tweebie && myPackage.tweebie.matchIds && myPackage.tweebie.matchIds.bookingLink) {
        myPackage.tweebie.bookingLink = myPackage.tweebie.matchIds.bookingLink;
      }
    }
    if (myPackage && myPackage.tweebie && !myPackage.tweebie.stcId) {
      if (myPackage.tweebie && myPackage.tweebie.matchIds && myPackage.tweebie.matchIds.stcId) {
        myPackage.tweebie.stcId = myPackage.tweebie.matchIds.stcId;
      }
    }
    this.myPackage = myPackage;
    if (!this.myPackage.tweebie.isMaster && !this.myPackage.tweebie.isDestination && this.myPackage.tweebie.destinationId) {
      const destination = await this.packageService.get(this.myPackage.tweebie.destinationId)
      this.qrCodeLinkBase = 'https://go.tweebie.com/' + destination.linkName;
      this.webLinkBase = 'https://web.tweebie.com/' + destination.linkName;
      this.isLoading = false;
    } else {
      this.isLoading = false;
    }
  }

  public async savePackage(): Promise<any> {
    await this.packageService.update(this.myPackage._id, this.myPackage).catch(err => {
      console.log('error catched: ', err);
    });
    this.snackbar.success(this.messages.general.savedChanges, 2000);
  }

  public addToMatchIds(value, key) {
    if (!value.length) {
      delete this.myPackage.tweebie.matchIds[key];
      return;
    }
    this.myPackage.tweebie.matchIds[key] = value;
  }

  public removeFromMatchIds(value, key) {
    this.myPackage.tweebie[key] = null;
    delete this.myPackage.tweebie.matchIds[key];
  }

  public readMe(name, tag) {
    this.readme.openReadMe({ tag: tag, name: name });
  }
}
